import { useEffect } from "react";
import { useState } from "react";

// changeCallback es el efecto a ejecutar cuando cambia la pagina
// Importante: Setear lastPage dentro de changeCallback para limitar la botonera
export default function usePaging(changeCallback) {
    const [current, setCurrent] = useState(1);

    useEffect(() => {
        changeCallback();
    }, [current]);

    const [lastPage, setLastPage] = useState(100);

    const [isPrevPage, setIsPrevPage] = useState(false);
    const [isNextPage, setIsNextPage] = useState(false);

    const changeCurrentPage = (num) => {
        setCurrent(prev => {
            let newPage = prev + num;

            if (newPage < 1)
                newPage = 1;
            if (newPage > lastPage)
                newPage = lastPage;

            return newPage;
        });
    }

    return {
        current, setCurrent,
        lastPage, setLastPage,
        isPrevPage, setIsPrevPage,
        isNextPage, setIsNextPage,
        changeCurrentPage
    }
}